export default {
    addGroupHoliday: 'Add Group Holiday',
    editGroupHoliday: 'Edit Group Holiday',
    groupHolidayName: 'Group Holiday Name',
    forGroup: 'For Group',
    holidayDate: 'Holiday Date',
    description: 'Description',
    save: 'Save',
    msgError: 'Error Message',
    congratulation: 'Congratulation',
    msgErrorStartTimeAndEndTime: 'start time should less than end time',
    msgCreateSuccess: 'Group Holiday is created.',
    msgUpdateSuccess: 'Group Holiday is updated.',
    msgRequiredField: 'This field is required',
    msgLimitCharacters: 'This field should be less than 255 characters'
}
